import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="Budget Calculator" link="https://github.com/namantaneja167/Budget-App" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  It's a dynamic app that can be used to calculate and track your spendings and
  income easily.It has a user-friendly designtoo
    </ProjectCard>
    <ProjectCard title="Pig -Dice Game" link="https://github.com/namantaneja167/Dice-Pig-Game" bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)" mdxType="ProjectCard">
  It's a game made using DOM manipulation and generates a random number on each
  click with a corresponding image on the screen. It's simple and fun to play.
    </ProjectCard>
    <ProjectCard title="ToDoList Using Local Storage" link="https://github.com/namantaneja167/To-do-List" bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)" mdxType="ProjectCard">
  A to-do list app using React and local storage feature with the ability to add
  and delete itemsin the list.
    </ProjectCard>
    <ProjectCard title="REST API" link="https://github.com/namantaneja167/natouros-API" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
  A full REST API made for a tour's website with all the features and complete
  login system and using pug template for front-end.
    </ProjectCard>
    <ProjectCard title="AirBnb Clone" link="https://github.com/namantaneja167/airbnb-clone-intialise-project" bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)" mdxType="ProjectCard">
  A Airbnb website clone using NextJS and Tailwind CSS.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      